import React, { useEffect, useState } from "react";
import Logobgtransparentblack from "../../images/DA_NoxZi/Logo-bg-transparent-black.png";
import { Link } from "react-router-dom";

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed left-0 top-0 z-50 w-full transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div
        className={`absolute inset-0 transition-all duration-500 ${
          scrolled
            ? "border-b border-black/[0.06] bg-white/70 backdrop-blur-md"
            : "bg-transparent"
        }`}
      />

      <div className="relative mx-auto flex max-w-7xl items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={Logobgtransparentblack}
            alt="Logo"
            className={`object-contain transition-all duration-500 ${
              scrolled ? "h-10 w-10" : "h-12 w-12"
            }`}
          />
        </Link>

        <nav className="hidden items-center gap-8 font-asap text-[14px] md:flex">
          <Link to="/" className="relative font-medium text-black">
            Accueil
            <span className="absolute left-0 -bottom-1 h-[1px] w-full bg-gradient-to-r from-black/60 to-transparent" />
          </Link>

          {[
            { label: "Services", href: "/services" },
            { label: "Bénéfices", href: "#benefices" },
            { label: "Nos Projects", href: "/projects"},
            { label: "Contact", href: "/contact" },
          ].map((item) => (
            <Link
              key={item.label}
              to={item.href}
              className="group relative text-black/70 transition-all duration-300 hover:text-black"
            >
              {item.label}
              <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-gradient-to-r from-[#c9a35f]/60 to-transparent transition-all duration-300 group-hover:w-full" />
            </Link>
          ))}
        </nav>

        <a
          href="https://cal.com/noxzi/30min"
          className={`group relative inline-flex items-center justify-center rounded-full bg-black font-asap font-medium text-white transition-all duration-500 hover:scale-[1.05] ${
            scrolled ? "px-4 py-2 text-[13px]" : "px-5 py-2.5 text-[14px]"
          } shadow-[0_10px_30px_rgba(0,0,0,0.2)]`}
        >
          <span className="relative z-10">Obtenir un devis</span>
          <span className="absolute inset-0 rounded-full bg-[radial-gradient(circle_at_center,rgba(201,163,95,0.25),transparent_60%)] opacity-0 transition duration-300 group-hover:opacity-100" />
        </a>
      </div>
    </header>
  );
}